import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "v-checkbox__control" }
const _hoisted_2 = { key: 0 }

import { useCheckboxVModel } from '@/utils/vue';
import CheckboxIcon from './icons/other/CheckboxIcon.vue';
import MinusIcon from './icons/other/MinusIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VCheckbox',
  props: {
    value: null,
    modelValue: { type: [Boolean, Array, Set] },
    label: null,
    alt: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { 
  value?: any, 
  modelValue?: boolean | any[] | Set<any>, 
  label?: string,
  alt?: boolean
}




const checked = useCheckboxVModel(props, emit)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-checkbox", { checked: _unref(checked) }]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (checked.value = !_unref(checked)), ["stop"]))
  }, [
    _createElementVNode("button", _hoisted_1, [
      (props.alt)
        ? (_openBlock(), _createBlock(MinusIcon, { key: 0 }))
        : (_openBlock(), _createBlock(CheckboxIcon, { key: 1 }))
    ]),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      (props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(props.label), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})